// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

// Connect to emulators if in local development
const useEmulator = process.env.REACT_APP_FIREBASE_USE_EMULATOR === "true";

if (useEmulator) {
  console.log("🔥 Connecting to Firebase emulators...");

  // Connect to Auth emulator
  if (process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST) {
    connectAuthEmulator(auth, `http://${process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST}`);
    console.log("✅ Connected to Auth emulator");
  }

  // Connect to Firestore emulator
  if (process.env.REACT_APP_FIREBASE_FIRESTORE_EMULATOR_HOST) {
    connectFirestoreEmulator(db, "localhost", 8080);
    console.log("✅ Connected to Firestore emulator");
  }

  // Connect to Storage emulator
  if (process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_HOST) {
    connectStorageEmulator(storage, "localhost", 9199);
    console.log("✅ Connected to Storage emulator");
  }
} else {
  console.log("🚀 Using Firebase production services");
}

export default app;
